import LoginPage from "../Pages/Common/Login/Login";
import HomePage from "../Pages/Common/index.jsx";
import FundraisersForm from "../Pages/Common/Fundraisers/FundraisersCreate/FundraisersCreate.jsx";
import FundraiserHeroCreate from "../Pages/GSA/FundraisersHeroCreate/FundraisersHeroCreate.jsx";
import ParticipantsCreate from "../Pages/Common/Participants/ParticipantsCreate/ParticipantsCreate.jsx";
import GSACreate from "../Pages/SuperAdmin/GSACreate/GSACreate.jsx";
import ParticipantDashboard from "../Pages/ParticipantDashboard/ParticipantDashboard.jsx";
import FundraiserDashboard from "../Pages/Common/FundraiserDashboard/FundraiserDashboard.jsx";
import TeamsForm from "../Pages/Common/Teams/TeamsForm/TeamsForm.jsx";

const protectedRoutes = [
    {
        path: "",
        component: <HomePage />
    },
    {
        path: "fundraisers",
        component: <FundraisersForm />
    },
    {
        path: "gsa",
        component: <GSACreate />
    },
    {
        path: "fundraiser-hero",
        component: <FundraiserHeroCreate />
    },
    {
        path: "participants",
        component: <ParticipantsCreate />
    },
    {
        path: "teams",
        component: <TeamsForm />
    },
    {
        path: "fundraiser/:id",
        component: <FundraiserDashboard />
    }
];

const publicRoutes = [
    {
        path: "login",
        component: <LoginPage />
    },
    {
        path: "participant-dashboard/:id",
        component: <ParticipantDashboard />
    }
];

export { protectedRoutes, publicRoutes };